// avstemming-equity-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avbe.page.noAccount': 'The equity area has no reconciliation account in this period.',
  'avbe.accountingData': 'Accounting data',
  'avbe.statement.title': 'Statement of changes in equity',
  'avbe.nav.differences': '{count} difference',
  'avbe.reconciled': 'Reconciled',
  'avbe.changes.title': 'Changes in equity',
  'avbe.nav.movements': '{count} movements',
  'avbe.capital.title': 'Capital and owners',
  'avbe.nav.equityLiquidity': 'Equity and liquidity',
  'avbe.nav.documentation': 'Documentation',
  'avbe.nav.missing': '{count} missing',
  'avbe.complete': 'Complete',
  'avbe.nav.itemsToAssess': 'Items to assess',
  'avbe.nav.open': '{count} open',
  'avbe.nav.controls': 'Review and approval',
  'avbe.areaLabel': 'Equity',
  'avbe.page.hintOpen': '{count} flagged items have not been fully assessed.',
  'avbe.page.hintAllDone': 'All flagged items have been assessed.',
  'avbe.page.heading': 'Equity — statement, resolutions and soundness',
  'avbe.responsible': 'Responsible: {name}',
  'avbe.page.distNoBasis': '{count} distribution without a decision basis',
  'avbe.itemsNeedAssessment': '{count} items require assessment',
  'avbe.page.noOpenItems': 'No open items',
  'avbe.page.unexplainedDiff': 'The statement of changes in equity has an unexplained calculation difference of {amount}.',
  'avbe.page.noCalcDeviation': 'Equity is reconciled with no calculation deviations.',
  'avbe.page.lossReduced': 'The loss for the period has reduced equity by {amount}.',
  'avbe.page.profitIncreased': 'The profit for the period has increased equity by {amount}.',
  'avbe.page.distMissingOne': '{count} distribution is missing a decision basis.',
  'avbe.page.distMissingMany': '{count} distributions are missing a decision basis.',
  'avbe.page.ytdNote': 'Equity is reconciled year to date: the opening balance at the start of the year, the movements up to the end of the period, and the closing balance at the end of the period. Registered share capital and capital changes in the Register of Business Enterprises (Foretaksregisteret) are not retrieved by the app and must be checked manually.',
  'avbe.sources.title': 'Data sources',
  'avbe.sources.missingOne': '{count} source is not in place for the year.',
  'avbe.sources.missingMany': '{count} sources are not in place for the year.',
  'avbe.sources.allInPlace': 'The sources the reconciliation reads are in place for the year.',
  'avbe.sources.source': 'Source',
  'avbe.status': 'Status',
  'avbe.details': 'Details',
  'avbe.sources.unavailable': 'Not available',
  'avbe.sources.incomplete': 'Incomplete',
  'avbe.requestDocsClient': 'Ask the client for documentation',
  'avbe.group.paidIn': 'Paid-in equity',
  'avbe.group.retained': 'Retained equity',
  'avbe.overview.readFromLedger': 'Read from the general ledger {date}',
  'avbe.overview.bookedEquity': 'Booked equity on equity accounts',
  'avbe.overview.accumulatedResult': 'Accumulated period result',
  'avbe.overview.transferred': 'Transferred to equity',
  'avbe.overview.notTransferred': 'Not transferred',
  'avbe.overview.computedInclResult': 'Computed equity incl. result',
  'avbe.overview.previousEquity': 'Equity previous period',
  'avbe.overview.equityChange': 'Change in equity',
  'avbe.equityRatio': 'Equity ratio',
  'avbe.overview.ratioSub': 'Assessed together with risk and liquidity',
  'avbe.overview.hideAccounts': 'Hide account overview',
  'avbe.overview.showAccounts': 'Show account overview',
  'avbe.account': 'Account',
  'avbe.opening': 'Opening',
  'avbe.additions': 'Additions',
  'avbe.disposals': 'Disposals',
  'avbe.closing': 'Closing',
  'avbe.change': 'Change',
  'avbe.vouchers': 'Vouchers',
  'avbe.tile.noVoucher': 'Movement without voucher coverage',
  'avbe.matches': 'Matches',
  'avbe.overview.accountsNote': 'Additions and disposals are the sum of the vouchers on the account year to date. Closing is the trial balance\'s own figure.',
  'avbe.tile.noDecisionBasis': 'Distribution without a decision basis',
  'avbe.tile.calcDifference': 'Calculation difference in the statement',
  'avbe.tile.directPosting': 'Direct posting to equity',
  'avbe.tile.ownerTransaction': 'Transaction with owner',
  'avbe.tile.negativeEquity': 'Negative equity',
  'avbe.tile.noShareCapital': 'No booked share capital',
  'avbe.tile.noShareRegister': 'Share register not recorded',
  'avbe.control.title': 'Control card',
  'avbe.control.summary': '{checks} automatic checks run · {flagged} items require assessment · {done} assessed',
  'avbe.control.categoriesReconciled': 'Equity categories reconciled',
  'avbe.control.categoriesOf': '{done} of {total}',
  'avbe.control.categoriesSub': 'Computed closing against booked',
  'avbe.itemsRequireAssessment': 'Items requiring assessment',
  'avbe.control.foundNothing': 'The checks found nothing',
  'avbe.control.activeFilter': 'Active filter: {label} · {count} items',
  'avbe.control.reset': 'Reset',
  'avbe.checks.title': 'Automatic checks',
  'avbe.checks.note': 'The checks do not tick off anything in the professional checklist. They tell the person ticking off what to have looked at.',
  'avbe.checks.check': 'Check',
  'avbe.checks.run': 'Run',
  'avbe.checks.findings': 'Findings',
  'avbe.checks.ran': 'Run',
  'avbe.checks.findingsCount': '{count} findings',
  'avbe.checks.noFindings': 'No findings',
  'avbe.statement.ytd': 'Year to date · {from}–{to}',
  'avbe.statement.category': 'Equity category',
  'avbe.statement.periodResult': 'Period result',
  'avbe.statement.computedClosing': 'Computed closing',
  'avbe.statement.booked': 'Booked',
  'avbe.difference': 'Difference',
  'avbe.mustAssess': 'Needs assessment',
  'avbe.statement.zeroRows': '{count} other equity categories have no balance or movements.',
  'avbe.statement.showZero': 'Show {count} zero items',
  'avbe.statement.noBalance': 'No balance',
  'avbe.statement.hideZero': 'Hide zero items',
  'avbe.statement.sumBooked': 'Total booked equity accounts',
  'avbe.statement.resultTransferred': 'Period result transferred to equity',
  'avbe.statement.resultNotTransferred': 'Period result not transferred',
  'avbe.statement.computedInclResult': 'Computed equity including result',
  'avbe.statement.noteTransferred': 'The period result has been transferred to the equity accounts and is therefore not added again in the calculation.',
  'avbe.statement.noteNotTransferred': 'The period result has not been transferred to the equity accounts and is therefore added to computed equity. It is not counted twice.',
  'avbe.statement.notePrevYear': 'Last year\'s result is already included in opening equity. The appropriation of profit splits the amount between dividends and other retained equity without adding the result again.',
  'avbe.changes.countOne': '{count} movement year to date',
  'avbe.changes.countMany': '{count} movements year to date',
  'avbe.changes.none': 'No equity transactions have been booked year to date.',
  'avbe.date': 'Date',
  'avbe.type': 'Type',
  'avbe.description': 'Description',
  'avbe.amount': 'Amount',
  'avbe.category': 'Category',
  'avbe.changes.counterAccount': 'Counter account',
  'avbe.changes.decisionDate': 'Decision date',
  'avbe.changes.decisionBasis': 'Decision basis',
  'avbe.changes.noCounterTitle': 'The voucher has no counter-posting outside equity',
  'avbe.changes.noCounter': 'No counter account',
  'avbe.changes.notRequired': 'Not required',
  'avbe.documented': 'Documented',
  'avbe.missing': 'Missing',
  'avbe.changes.noAlert': 'No alert',
  'avbe.assessed': 'Assessed',
  'avbe.seeAssessment': 'View assessment',
  'avbe.assess': 'Assess',
  'avbe.changes.requestMinutes': 'Request minutes',
  'avbe.changes.note': 'The assessments book nothing. A correction is made on the voucher, and a distribution that lacks a resolution is resolved by the minutes — not by a tick here.',
  'avbe.quick.needsAssessment': 'Needs assessment',
  'avbe.assessedDone': 'Assessed',
  'avbe.quick.all': 'All',
  'avbe.items.resetFilters': 'Reset filters',
  'avbe.items.noneInFilter': 'No items in this filter.',
  'avbe.items.noneFound': 'The checks found no items that require assessment.',
  'avbe.items.item': 'Item',
  'avbe.items.alert': 'Alert',
  'avbe.assessment': 'Assessment',
  'avbe.action': 'Action',
  'avbe.capital.limitedCompany': 'Limited company',
  'avbe.capital.legalFormUnset': 'Legal form not set',
  'avbe.capital.bookedShareCapital': 'Booked share capital',
  'avbe.capital.bookedPremium': 'Booked share premium',
  'avbe.capital.ownShares': 'Own shares',
  'avbe.capital.sharesInRegister': 'Number of shares in the share register',
  'avbe.capital.shareholderCount': 'Number of shareholders',
  'avbe.capital.nominal': 'Nominal value per share',
  'avbe.capital.registeredCapital': 'Registered share capital (Foretaksregisteret)',
  'avbe.notFetched': 'Not retrieved by the app',
  'avbe.capital.articles': 'Articles of association',
  'avbe.capital.notUploaded': 'Not uploaded',
  'avbe.capital.agmRecorded': 'General meeting recorded',
  'avbe.capital.notRecorded': 'Not recorded',
  'avbe.capital.notFetchedNote': 'Plumme does not retrieve registered share capital, capital changes or the shareholder register statement. Booked share capital must be checked manually against Foretaksregisteret and the articles of association.',
  'avbe.capital.shareholder': 'Shareholder',
  'avbe.capital.shares': 'Shares',
  'avbe.capital.share': 'Share',
  'avbe.capital.noRegister': 'No share register is recorded in Plumme.',
  'avbe.capital.noRegisterHint': 'Ask the client for the share register, or record the owners in the annual closing.',
  'avbe.disp.title': 'Appropriation of the result for {year}',
  'avbe.disp.resolutionRecorded': 'Resolution recorded',
  'avbe.disp.mathMatchesNoResolution': 'The booking adds up mathematically — resolution missing',
  'avbe.disp.bookedDeviates': 'Booked appropriation deviates from the annual result',
  'avbe.disp.noneBooked': 'No appropriation booked',
  'avbe.disp.item': 'Item',
  'avbe.disp.proposed': 'Proposed',
  'avbe.disp.resolved': 'Resolved',
  'avbe.disp.notVerified': 'Not verified',
  'avbe.disp.prevResultUnreadable': 'Last year\'s annual result could not be read, so the appropriation cannot be compared with it.',
  'avbe.disp.sumsToResult': 'The booked appropriation adds up to last year\'s result.',
  'avbe.disp.notSumsToResult': 'The booked appropriation does not add up to last year\'s result.',
  'avbe.disp.noneBookedYtd': 'No appropriation of the result has been booked year to date.',
  'avbe.disp.resolutionRecordedAt': 'The resolution is recorded at the general meeting on {date}.',
  'avbe.disp.cannotVerify': 'The resolved appropriation cannot be verified until the general meeting is recorded or the minutes are received.',
  'avbe.disp.requestAgmMinutes': 'Ask the customer for the general meeting minutes',
  'avbe.liq.title': 'Assessment of equity and liquidity',
  'avbe.liq.documented': 'Assessment documented',
  'avbe.computedEquity': 'Computed equity',
  'avbe.liq.changeSincePrevious': 'Change since previous period',
  'avbe.liq.workingCapital': 'Working capital',
  'avbe.liq.liquidAssets': 'Liquid assets',
  'avbe.liq.overduePayables': 'Overdue accounts payable',
  'avbe.liq.items': '{count} items',
  'avbe.yes': 'Yes',
  'avbe.no': 'No',
  'avbe.liq.bankData': 'Bank data for the year',
  'avbe.liq.budgetAvailable': 'Budget available',
  'avbe.liq.forecastAvailable': 'Liquidity forecast available',
  'avbe.liq.noteSoundness': 'The assessment of adequate equity and liquidity must be seen in the context of the business\'s risk, scale, liquidity and future prospects. Plumme provides the basis — the assessment is made by the board and the accountant.',
  'avbe.liq.noteFuture': 'Future development cannot be assessed from the figures alone: neither a budget nor a liquidity forecast is available for the year.',
  'avbe.liq.confirmation': 'Assessment and the board\'s confirmation',
  'avbe.liq.confirmationRequired': 'Assessment and the board\'s confirmation (required)',
  'avbe.liq.confirmationPlaceholder': 'What does the review show, and what has the board confirmed? Refer to board minutes or written confirmation.',
  'avbe.savedAsReason': 'Saved as the justification on the checkpoint «{label}».',
  'avbe.liq.requestBoardAssessment': 'Ask the customer for the board\'s assessment',
  'avbe.docs.title': 'Documentation and decision basis',
  'avbe.docs.basis': 'Basis',
  'avbe.docs.inPlace': 'In place',
  'avbe.requestDocsCustomer': 'Ask the customer for documentation',
  'avbe.docs.attached': 'Attached documentation',
  'avbe.docs.empty': 'No documents have been uploaded to the equity area for this period. Upload them in the documents tab in the right-hand panel.',
  'avbe.derived.noDecisionBasis': 'Distributions without a decision basis have been handled',
  'avbe.derived.calcDifferences': 'Calculation differences in the statement have been handled',
  'avbe.derived.noVoucher': 'Movements without voucher coverage have been handled',
  'avbe.derived.directPostings': 'Direct postings to equity have been assessed',
  'avbe.derived.ownerTransactions': 'Transactions with owners have been assessed',
  'avbe.derived.negativeEquity': 'Signs of negative equity have been handled',
  'avbe.derived.noShareCapital': 'Missing booked share capital has been handled',
  'avbe.derived.noShareRegister': 'Missing share register has been handled',
  'avbe.checklist.title': 'Professional checklist',
  'avbe.checklist.titleReadOnly': 'Professional checklist (the preparer\'s, read-only)',
  'avbe.checklist.none': 'No checkpoints are defined for equity in this period.',
  'avbe.checklist.note': 'The points apply to the whole equity area. A tick is saved on all equity accounts in the period.',
  'avbe.checklist.groupItems': 'Items that require handling',
  'avbe.checklist.countOf': '{done} of {total}',
  'avbe.checklist.handledOf': '{done} of {total} handled',
  'avbe.checklist.notApplicable': 'Not applicable this period',
  'avbe.checklist.followsAssessments': 'Follows from the assessments',
  'avbe.checklist.groupAssessments': 'Overall professional assessments',
  'avbe.checklist.groupReady': 'Readiness',
  'avbe.checklist.performedBy': 'Performed by {name}',
  'avbe.checklist.doneOfTotal': '{done} of {total} checkpoints completed',
  'avbe.blocker.distOne': 'One distribution is missing a documented decision basis',
  'avbe.blocker.distMany': '{count} distributions are missing a documented decision basis',
  'avbe.blocker.deviates': 'Computed equity deviates from booked equity',
  'avbe.blocker.assessmentUndocumented': 'The assessment of equity and liquidity is not documented',
  'avbe.blocker.checkpointOne': '{count} checkpoint remaining',
  'avbe.blocker.checkpointMany': '{count} checkpoints remaining',
  'avbe.conclusion.title': 'Conclusion and approval',
  'avbe.conclusion.changeThisPeriod': 'Change this period',
  'avbe.conclusion.unexplainedDiff': 'Unexplained calculation difference',
  'avbe.conclusion.transactions': 'Equity transactions',
  'avbe.conclusion.incompleteCheckpoints': 'Incomplete checkpoints',
  'avbe.conclusion.overallStatus': 'Overall status',
  'avbe.conclusion.notReady': 'Not ready for review',
  'avbe.conclusion.ready': 'Ready for review',
  'avbe.conclusion.label': 'Conclusion',
  'avbe.conclusion.placeholder': 'What does the review of equity show for this period?',
  'avbe.conclusion.remainingRisk': 'Remaining risk',
  'avbe.conclusion.nothingBlocking': 'Nothing remains that prevents the area from being sent for review. Registered share capital and capital changes in Foretaksregisteret are not retrieved by the app and have been checked manually.',
  'avbe.followup.title': 'Follow-up next period',
  'avbe.followup.none': 'No assessments are marked for follow-up next period.',
  'avbe.followup.badge': 'Follow up',
  'avbe.followup.actionLine': 'Action: {action}',
  'avbe.followup.noAction': 'No action noted',
  'avbe.followup.due': 'Due {date}',
  'avbe.followup.open': 'Open assessment',
  'avbe.conclusion.send': 'Send the area for review',
  'avbe.conclusion.oneThingLeft': 'One thing remains before the area can be sent.',
  'avbe.conclusion.thingsLeft': '{count} things remain before the area can be sent.',
  'avbe.assessments.notAssessed': 'Not assessed',
  'avbe.assessments.decisionDocumented': 'Decision basis received and verified',
  'avbe.assessments.decisionRequested': 'Decision basis being obtained from the client',
  'avbe.assessments.appropriationToBook': 'Appropriation of the result to be booked',
  'avbe.assessments.reclassWithinEquity': 'Reclassify within equity',
  'avbe.assessments.reclassToDebt': 'Reclassify to liability or receivable',
  'avbe.assessments.capitalChange': 'Capital change to be registered',
  'avbe.assessments.assessedWithBoard': 'Equity and liquidity assessed with the board',
  'avbe.assessments.noCorrection': 'No correction needed',
  'avbe.assessments.wrongBooking': 'Incorrect booking — to be corrected',
  'avbe.assessments.awaitingDocs': 'Awaiting documentation',
  'avbe.assessments.awaitingClient': 'Awaiting the client',
  'avbe.followUpNext': 'Follow up next period',
  'avbe.close': 'Close',
  'avbe.drawer.appliesTo': 'Applies to',
  'avbe.drawer.rationaleRequired': 'Professional rationale (required)',
  'avbe.drawer.rationale': 'Professional rationale',
  'avbe.drawer.rationalePlaceholder': 'What does the item concern, and what is the assessment based on? Refer to minutes, resolutions or vouchers.',
  'avbe.drawer.actionPlaceholder': 'E.g. Obtain the general meeting minutes, or correct the voucher',
  'avbe.drawer.followUpDue': 'Follow-up deadline',
  'avbe.drawer.needsComment': 'This assessment requires a rationale.',
  'avbe.drawer.save': 'Save assessment',
});
